var moduleMap = {
	"./HomepagesWebComponent": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_inheritsLoose_js-node_modules_emotion_serializ-a98d4d"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_asyncToGenerator_js-node_modules_babel_runtime-774056"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_emotion_core_emotion_core-webpack_sharing_consume_default_pro-89be05"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("src_AppMain_tsx-data_application_font-woff_charset_utf-8_base64_d09GRgABAAAAABDkAAsAAAAAG6gAA-a277ea"), __webpack_require__.e("src_components_WebComponent_HomepagesWebComponent_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/components/WebComponent/HomepagesWebComponent.tsx */ "./src/components/WebComponent/HomepagesWebComponent.tsx")))));
	},
	"./Homepages": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_inheritsLoose_js-node_modules_emotion_serializ-a98d4d"), __webpack_require__.e("vendors-node_modules_babel_runtime_helpers_esm_asyncToGenerator_js-node_modules_babel_runtime-774056"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_emotion_core_emotion_core-webpack_sharing_consume_default_pro-89be05"), __webpack_require__.e("src_AppMain_tsx-data_application_font-woff_charset_utf-8_base64_d09GRgABAAAAABDkAAsAAAAAG6gAA-a277ea")]).then(() => (() => ((__webpack_require__(/*! ./src/AppMain.tsx */ "./src/AppMain.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});